import React from 'react'

// material ui
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Box from '@mui/material/Box'

const WaiverWrapper = props => {
  const { children } = props

  return (
    <Box mb={4}>
      <Card elevation={1}>
        <CardContent>
          <Box p={[1, 4, 6]}>{children}</Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default WaiverWrapper
